/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Usage_MonthInputs */

const fr_admin_subscription_rights_usage_month = /** @type {(inputs: Admin_Subscription_Rights_Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consommation du mois`)
};

/**

* @param {Admin_Subscription_Rights_Usage_MonthInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_usage_month = /** @type {((inputs?: Admin_Subscription_Rights_Usage_MonthInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Usage_MonthInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_usage_month(inputs)
});